/** --------------------------------------------------
*
*   components
*   DESKTOP MAIN NAVIGATION
*
*  -------------------------------------------------- */

(function (Drupal, once, duo) {
  Drupal.behaviors.desktopMainNav = {
    selector: 'header-mainnavigation',
    selectorPageWrapper: 'site-page-wrapper',
    selectorUserMenu: '.user-header-menu',
    menu: [],

    attach: function (context, settings) {
      const behavior = Drupal.behaviors.desktopMainNav;
      behavior.menu = [...once('mobile-menu-once', '#' + behavior.selector)];

      if (behavior.menu.length <= 0) {
        return;
      }

      /* Wait until Drupal has loaded the user menu before init navigation */
      const patienceMyDear = setInterval(function () {
        if (document.body.querySelector(behavior.selectorUserMenu) != null) {
          clearInterval(patienceMyDear);
          behavior.init();
        }
      }, 150);
    },

    init: function(context, settings) {
      const behavior = Drupal.behaviors.desktopMainNav;

      /* TODO: fix later the quick fix :), push menu as object again , once in attach does strange things */
      behavior.menu = document.getElementById(behavior.selector);

      /* check if panel menu should be divided in columns */
      behavior.checkCols();

      /* check if the panel overlaps the site wrapper or viewport */
      behavior.checkBoundaries();

      /* on resize, check bounderaries again */
      window.addEventListener('resize', (e) => {
        behavior.checkBoundaries();
      }, true);
    },

    checkBoundaries: function() {
      const behavior = Drupal.behaviors.desktopMainNav;

      // Check if menu is a DOM element before calling querySelectorAll
      if (!behavior.menu || typeof behavior.menu.querySelectorAll !== 'function') {
        return;
      }

      const panelMenus = behavior.menu.querySelectorAll('.menu__panel');
      const pageWrapperBoundary = document.getElementById(behavior.selectorPageWrapper).getBoundingClientRect();

      if (panelMenus) {
        panelMenus.forEach(panelMenu => {
          /* remove inline transform style */
          panelMenu.style.removeProperty('transform');
          const panelBoundary = panelMenu.getBoundingClientRect();

          /* if the right boundary overlaps the pagewrapper right boundary, calc the diff and transform negative x value) */
          if (panelBoundary.right > pageWrapperBoundary.right) {
            const diff = Math.ceil((panelBoundary.right - pageWrapperBoundary.right) * -1);
            panelMenu.style.transform = 'translateX(' + diff + 'px)';
          }
        });
      }

    },

    checkCols: function() {
      const behavior = Drupal.behaviors.desktopMainNav;

      // Check if menu is a DOM element before calling querySelectorAll
      if (!behavior.menu || typeof behavior.menu.querySelectorAll !== 'function') {
        return;
      }

      const panelMenus = behavior.menu.querySelectorAll('.menu__panel__menus');

      /* if menu has a flyout menus , loop through */

      if (panelMenus) {
        panelMenus.forEach(panelMenu => {
          const expandedMenus = panelMenu.querySelectorAll(':scope > .menu-item--expanded');
          const regularMenus = panelMenu.querySelectorAll(':scope > .menu-item:not(.menu-item--expanded)');
          const backLink = panelMenu.querySelector('.menu__back-link');
          const parentLink = panelMenu.querySelector('.menu__parent-repeat-link');

          /* remove back link, is only for mobile */
          if (backLink) {
            backLink.remove();
          }

          /* remove repeating link to page for mobile */
          if (parentLink) {
            parentLink.remove();
          }

          /* if the flyout menu contains a menu with submenus, create cols in flyout (max 3 cols, 2 expanded menus in first 2 cols, not expanded menus in last column) */
          const totalSubMenus = expandedMenus.length + regularMenus.length;

          if (expandedMenus.length > 1 && totalSubMenus > 1) {
            let colsCount = totalSubMenus >= 3 ? 3 : totalSubMenus;

            behavior.createCols(panelMenu, colsCount, regularMenus, expandedMenus);
          }
        });
      }
    },

    createCols(panelMenu, colsCount, regularMenus, expandedMenus) {
      const behavior = Drupal.behaviors.desktopMainNav;

      /* set cols class on panelMenu */
      panelMenu.classList.add('panel-menu--' + colsCount + '-col');

      let panelMenuNewCols = [];

      for (let i = 1; i <= colsCount; i++) {
        let col = document.createElement('li');
        col.classList.add('panel-menu__col', 'panel-menu__col-' + i);
        panelMenu.append(col);
        panelMenuNewCols.push(col);
      }

      /* place expandedMenus */
      for (let i = 0; i < expandedMenus.length; i++) {
        let col = false;

        if ((i % 2) == 0) {
          col = panelMenu.querySelector('.panel-menu__col-1');
        } else {
          col = panelMenu.querySelector('.panel-menu__col-2');
        }

        if (col) {
          let list = document.createElement('ul');
          list.append(expandedMenus[i]);
          col.append(list);
        }
      }

      /* place regularMenus */
      if (regularMenus.length > 0) {
        let list = document.createElement('ul');
        for (let i = 0; i < regularMenus.length; i++) {
          list.append(regularMenus[i]);
        }

        panelMenu.querySelector('.panel-menu__col-' + colsCount).append(list);
      }
    }
  };
})(Drupal, once, window.duo = window.duo || {});
